import { HttpClient } from '#client/http/index'
import {
  ListPlansResponse,
  ListSubscriptionsResponse,
} from '#client/resources/index'

export const listPlans = async ({ httpClient }: { httpClient: HttpClient }) => {
  const data: ListPlansResponse = await httpClient.get(
    `/user/pointSubscriptions/plans`,
  )
  return data
}

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ListSubscriptionsResponse = await httpClient.get(
    '/user/pointSubscriptions',
  )
  return data
}

export const subscribe = async (
  { httpClient }: { httpClient: HttpClient },
  planId: string,
) => {
  return await httpClient.post(`/user/pointSubscriptions/subscribe`, {
    pointSubscriptionPlanId: planId,
  })
}

export const resume = async ({ httpClient }: { httpClient: HttpClient }) => {
  return await httpClient.put(`/user/pointSubscriptions/resume`)
}

export const cancel = async ({ httpClient }: { httpClient: HttpClient }) => {
  return await httpClient.put(`/user/pointSubscriptions/cancel`)
}

export const getExpiringPointsOnCancel = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: { data: number } = await httpClient.get(
    `/user/pointSubscriptions/pointToLoseByCancelPointSubscription`,
  )

  return data
}

export const submitCancelSurvey = async (
  { httpClient }: { httpClient: HttpClient },
  survey: {
    reasons: string[]
    intentToContinue: string
    otherReason?: string | null
  },
) => {
  return await httpClient.post(
    `/user/pointSubscriptions/surveyOnCancel`,
    survey,
  )
}
